import { PromoBannerType, TPromoBannerBase } from '@onesource/schemas';
import { FC } from 'react';

import { PromoBannerWithLaurenImage } from './banner-with-lauren';
import { PromoBannerDefault } from './promo-banner-default';

export interface PromoBannerProps {
  banner: TPromoBannerBase;
}

/**
 * Reusable, responsive promo banner. Dispatches to the layout configured by
 * `banner.type` (default | banner_with_lauren_image). Add a branch here to
 * introduce a new layout — callers keep using `<PromoBanner banner={...} />`
 * unchanged.
 */
export const PromoBanner: FC<PromoBannerProps> = ({ banner }) => {
  if (banner.type === PromoBannerType.BANNER_WITH_LAUREN_IMAGE) {
    return <PromoBannerWithLaurenImage banner={banner} />;
  }

  return <PromoBannerDefault banner={banner} />;
};
